import { snapMotif as snapMotifSdsm } from '@snapchat/snap-design-system-marketing';
/**
 * Reference to the snap motif from SDS-M. We re-export it here so it can be excluded by the bundler
 * on the client side for non-snap sites.
 */
export const snapMotif = snapMotifSdsm;
